import { AutoUnsubscribePattern } from 'features/campaigns/global_settings_api'

export const validateRow = (
  row: AutoUnsubscribePattern
): string | undefined => {
  if (!row.pattern.trim()) {
    return 'Pattern is required'
  }
  if (row.mode === 'regex') {
    try {
      new RegExp(row.pattern)
    } catch (err) {
      return `Invalid regex: ${(err as Error).message}`
    }
  }
  return undefined
}

export const findDuplicateError = (
  rows: AutoUnsubscribePattern[]
): string | undefined => {
  const seen = new Set<string>()
  for (const row of rows) {
    const key = `${row.pattern}::${row.mode}`
    if (seen.has(key)) {
      return 'Duplicate pattern + mode combinations are not allowed.'
    }
    seen.add(key)
  }
  return undefined
}

export const arePatternListsEqual = (
  a: AutoUnsubscribePattern[],
  b: AutoUnsubscribePattern[]
): boolean => {
  if (a.length !== b.length) return false
  return a.every((row, i) => {
    const other = b[i]
    return (
      row.pattern === other.pattern &&
      row.mode === other.mode &&
      row.enabled === other.enabled
    )
  })
}
